import { useTranslate } from '../../../customHooks';
import { makeStyles } from "@material-ui/core/styles";
import {  Sheet } from "@panwds/react-ui";
import { PANWDSForm, PANWDSRadioField } from '../../../components/PANWDSElements';
import { FormControl } from '@material-ui/core';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { isRequired } from '../../../utils/validate';
import { useEffect, useState } from 'react';
import PanoramaDetailPanel from './PanoramaDetailPanel';
import CloudManagerDetailPanel from './CloudManagerDetailPanel';


const useStyles = makeStyles((theme) => ({
    infoIcon: {
        fontSize: "14px",
    },
    iconedParagraph: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '5px',
        gap: '10px',
    },
    iconedParagraphTop: {
        display: 'flex',
        alignItems: 'top',
        gap: '5px',
    },
    pendingGrayText: {
        marginTop: "5px",
        color: '#707070 !important',
        fontSize: "12px",
    },
    grayText: {
        color: '#707070',
        fontSize: "14px",
    },
    checkIcon: {
        color: '#006FCC',
        fontSize: '18px',
        marginBottom: "-2px",
    },
    toolbar: {
        display: "flex",
        gap: theme.spacing(1),
        justifyContent: 'space-between',
        padding: '16px',
        borderTop: "1px solid #DADBDB",
        marginTop: 16,
    },
    innerToolbar: {
        display: "flex",
        gap: theme.spacing(1),
    },
    rightToolbar: {
        display: "flex",
        gap: theme.spacing(1),
        justifyContent: 'flex-end',
        padding: '0 16px',

    },
    sidePanelForm: {
        padding: '20px 16px',
        '& .ra-input ': {
            padding: '7px 0',
        }
    },
    circle: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
    },
    circleActive: {
        backgroundColor: '#33CCB8',
    },
    circleInActive: {
        backgroundColor: '#707070;',
    },
    circlePending: {
        backgroundColor: '#EF9700',
    },
    iconAndText: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
    },
    notes: {
        fontSize: 12,
        color: '#333333',
    },
    pending: {
        color: "#B8B8B8",
        "& a, & .iconedParagraph, & div": {
            color: "#B8B8B8",
        },
    },
    enabledColor: {
        color: '#33CCB8',
    },
    disabledColor: {
        color: '#707070',
    },
    labelControl: {
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        margin: "10px 0px",
        '& > div': {
            marginBottom: "8px",
        },
        '& > div:first-child': {
            fontWeight: '600',
        },
    }
}));

export const IntegrationsDetailPanel = (props: any) => {
    const { close, record } = props;
    const translate = useTranslate();
    const classes = useStyles();
    const PolicyManagers = [
        { label: "Strata Cloud Manager", value: "CloudManager" },
        { label: "Panorama", value: "Panorama" }
    ]
    const [selectedManager, setSelectedManager] = useState(PolicyManagers[0].value);

    const handleSelectedManager = (selected: any) => {
        setSelectedManager(selected);
    }

    useEffect(() => {
        const selManager = props?.selectedPanorama?.hasOwnProperty('CloudManager')? PolicyManagers[0]?.value : PolicyManagers[1]?.value;
        setSelectedManager(selManager);
    }, [])

    const getDefaultValue = (selectedPanorama: any) => {
        return selectedPanorama?.hasOwnProperty('CloudManager')? PolicyManagers[0]?.value : PolicyManagers[1]?.value;
    }

    const getDisabledValue = (selectedPanorama: any) => {
        return selectedPanorama?.hasOwnProperty('CloudManager')? PolicyManagers[1]?.value : PolicyManagers[0]?.value;
    }

    return (
        <Sheet
            onClose={() => close()}
            title={translate(`resources.integrations.panel.editPolicyManagement`)}
            isOpen
            showMask={true}
        >
            <div className={classes.sidePanelForm}>
                <PANWDSForm onSubmit={() => null} toolbar={false}>
                    <FormControl fullWidth>
                        <Field
                            name="PolicyManager"
                            row
                            // @ts-ignore
                            component={PANWDSRadioField}
                            options={PolicyManagers}
                            title={'Manage Type'}
                            validate={isRequired}
                            defaultValue={getDefaultValue(props.selectedPanorama)}
                            disabled={getDisabledValue(props.selectedPanorama)}
                        />
                        <OnChange name="PolicyManager">
                            {(selected: any) => handleSelectedManager(selected)}
                        </OnChange>
                    </FormControl>
                </PANWDSForm>

                {selectedManager == PolicyManagers[0].value && <CloudManagerDetailPanel {...props} />}

                {selectedManager == PolicyManagers[1].value && <PanoramaDetailPanel {...props} />}

            </div>
        </Sheet>
    );
};
